import React, { useEffect, useMemo, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import Slider from 'react-slick'
import './ProgramView.css'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const API_BASE = 'https://backend.alephmedia.ro/api'

const SOCIAL_ICONS = {
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  ),
  website: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="2" y1="12" x2="22" y2="12"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  )
}

function getSocialIcon(label = '') {
  const lowerLabel = label.toLowerCase()
  for (const key in SOCIAL_ICONS) {
    if (lowerLabel.includes(key)) {
      return SOCIAL_ICONS[key]
    }
  }
  return SOCIAL_ICONS.website
}

const DEFAULT_PROGRAM = {
  id: null,
  title: '',
  description: '',
  image_16_9: '',
  image_9_16: '',
  links: [],
  seasons: []
}

const ArrowButton = ({ direction, onClick }) => {
  const isNext = direction === 'next'
  return (
    <button
      type="button"
      className={`program-view-arrow program-view-arrow-${direction}`}
      onClick={onClick}
      aria-label={isNext ? 'Următorul set de episoade' : 'Setul anterior de episoade'}
    >
      {isNext ? (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
  )
}

const ProgramView = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [program, setProgram] = useState(DEFAULT_PROGRAM)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [selectedSeasonId, setSelectedSeasonId] = useState(null)
  const [visibleEpisodesPerSeason, setVisibleEpisodesPerSeason] = useState({})
  const [isLoadingSeason, setIsLoadingSeason] = useState(false)
  const [loadedSeasons, setLoadedSeasons] = useState(new Set()) // Track which seasons have episodes loaded

  useEffect(() => {
    if (!id) {
      navigate('/v3.0')
    }
  }, [id, navigate])

  // Funcție pentru a încărca episoadele unui sezon
  const loadSeasonEpisodes = React.useCallback(async (seasonId, limit = 100, offset = 0) => {
    if (!id || !seasonId) return
    
    setIsLoadingSeason(true)
    try {
      const response = await fetch(`${API_BASE}/programs/${id}?season_id=${seasonId}&include_episodes=true&episodes_limit=${limit}&episodes_offset=${offset}`)
      if (!response.ok) {
        throw new Error(`Nu am putut încărca episoadele. Cod: ${response.status}`)
      }
      const json = await response.json()
      if (!json.success || !json.data) {
        throw new Error('Răspuns invalid de la server.')
      }
      
      // Actualizează programul cu episoadele încărcate
      setProgram(prevProgram => {
        // Verifică dacă sezonul are deja episoade (pentru a evita re-încărcarea)
        const existingSeason = prevProgram.seasons.find(s => s.id === seasonId)
        if (existingSeason && existingSeason.episodes && existingSeason.episodes.length > 0) {
          // Sezonul are deja episoade, nu re-încărca
          return prevProgram
        }
        
        const updatedSeasons = prevProgram.seasons.map(season => {
          if (season.id === seasonId) {
            return {
              ...season,
              episodes: json.data.seasons[0]?.episodes || []
            }
          }
          return season
        })
        return {
          ...prevProgram,
          seasons: updatedSeasons
        }
      })
      
      setLoadedSeasons(prev => new Set([...prev, seasonId]))
    } catch (err) {
      console.error('loadSeasonEpisodes failed', err)
      setError(err.message || 'Nu am putut încărca episoadele sezonului.')
    } finally {
      setIsLoadingSeason(false)
    }
  }, [id])

  useEffect(() => {
    const stateProgram = location.state?.program
    if (stateProgram) {
      setProgram({ ...DEFAULT_PROGRAM, ...stateProgram })
    }

    async function loadProgram() {
      if (!id) return
      setLoading(true)
      setError(null)
      try {
        // Încarcă doar metadata (fără episoade) pentru a evita problemele de memorie
        const response = await fetch(`${API_BASE}/programs/${id}?include_episodes=false`)
        if (!response.ok) {
          throw new Error(`Nu am putut încărca programul. Cod: ${response.status}`)
        }
        const json = await response.json()
        if (!json.success || !json.data) {
          throw new Error('Răspuns invalid de la server.')
        }
        setProgram({ ...DEFAULT_PROGRAM, ...json.data })
        
        // Încarcă automat primele 2 sezoane (indiferent de numărul total de episoade)
        // Backend-ul returnează deja sezoanele sortate descrescător (cele mai recente primele)
        if (json.data.seasons && json.data.seasons.length > 0) {
          const firstTwoSeasons = json.data.seasons.slice(0, 2)
          for (const season of firstTwoSeasons) {
            if (season.id && season.episodes_count > 0) {
              await loadSeasonEpisodes(season.id, 50) // Încarcă primele 50 episoade
            }
          }
        }
      } catch (err) {
        console.error('loadProgram failed', err)
        setError(err.message || 'Nu am putut încărca programul selectat.')
      } finally {
        setLoading(false)
      }
    }

    loadProgram()
  }, [id, loadSeasonEpisodes])

  const handleEpisodeClick = (episode) => {
    // Aici poți adăuga logica pentru redarea episodului
  }

  const desktopPoster = useMemo(() => program.image_16_9 || program.image_9_16 || null, [program.image_16_9, program.image_9_16])
  const mobilePoster = useMemo(() => program.image_9_16 || program.image_16_9 || null, [program.image_9_16, program.image_16_9])
  const programLinks = program.links || []
  const programDescription = useMemo(() => (program.description || '').trim(), [program.description])

  // Funcție pentru a încărca mai multe episoade pentru un sezon
  const loadMoreEpisodes = (seasonId) => {
    const season = program.seasons.find(s => s.id === seasonId);
    if (!season) return;

    const currentVisible = visibleEpisodesPerSeason[seasonId] || 12;
    const nextBatch = Math.min(currentVisible + 12, season.episodes.length);
    
    setVisibleEpisodesPerSeason(prev => ({
      ...prev,
      [seasonId]: nextBatch
    }));
  };

  // Funcție pentru a obține episoadele vizibile pentru un sezon
  const getVisibleEpisodes = (seasonId, allEpisodes) => {
    const visibleCount = visibleEpisodesPerSeason[seasonId] || 12;
    return allEpisodes.slice(0, visibleCount);
  };

  // Curăță HTML-ul de tag-uri <p> și <strong>, păstrează doar inline styling (em, b, i)
  const sanitizeSubtitle = (html) => {
    if (!html) return ''
    // Elimină tagurile <p> și <strong>, păstrează tagurile inline (em, b, i)
    return html
      .replace(/<p>/gi, '')
      .replace(/<\/p>/gi, ' ')
      .replace(/<strong>/gi, '')
      .replace(/<\/strong>/gi, '')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<div>/gi, '')
      .replace(/<\/div>/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim()
  }

  const renderEpisodeCard = (episode, index) => {
    const fallbackPoster = '/placeholder-episode.jpg'
    const desktopPoster = episode.poster_image_16_9 || episode.image_16_9 || episode.video_16_9_url || fallbackPoster
    const mobilePoster = episode.poster_image_9_16 || episode.image_9_16 || desktopPoster
    const title = episode.title || `Episodul ${index + 1}`
    const rawSubtitle = (episode.subtitle || episode.description || '').trim()
    const subtitle = rawSubtitle ? sanitizeSubtitle(rawSubtitle) : ''

    return (
      <div
        key={episode.id ?? `episode-${index}`}
        className="program-view-card"
        role="button"
        tabIndex={0}
        onClick={(e) => {
          navigate(`/v3.0/programs/${program.id}/episodes/${episode.id}`, { state: { program, episode } });
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            navigate(`/v3.0/programs/${program.id}/episodes/${episode.id}`, { state: { program, episode } })
          }
        }}
      >
        <div className="program-view-card-image">
          <picture>
            <source media="(max-width: 768px)" srcSet={mobilePoster} />
            <img
              src={desktopPoster}
              alt={title}
              loading={index < 6 ? "eager" : "lazy"}
              onError={(event) => {
                event.currentTarget.src = fallbackPoster
              }}
            />
          </picture>
          <span className="program-view-card-play">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 5V19L19 12L8 5Z" fill="white" />
            </svg>
          </span>
        </div>
        <div className="program-view-card-title">{title}</div>
        {subtitle && (
          <div 
            className="program-view-card-subtitle"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
      </div>
    )
  }

  const renderSeason = (season, seasonIndex) => {
    const episodes = season.episodes || []
    const episodesCount = season.episodes_count || episodes.length || 0
    const seasonDescription = (season.description || season.synopsis || '').trim()
    const seasonTitle = season.title || `Sezonul ${seasonIndex + 1}`
    const isLoaded = loadedSeasons.has(season.id) || (episodes && episodes.length > 0)
    
    // Obține episoadele vizibile pentru acest sezon
    const visibleEpisodes = getVisibleEpisodes(season.id, episodes)
    const hasMoreEpisodes = episodesCount > 0 && (visibleEpisodes.length < episodesCount || (episodes.length > 0 && visibleEpisodes.length < episodes.length))
    return (
      <div key={season.id ?? `season-${seasonIndex}`} id={`season-${season.id}`} className="program-view-season">
        <div className="program-view-season-header">
          <h3>{seasonTitle}</h3>
          <span className="program-view-season-count">{episodesCount} episoade</span>
        </div>
        {seasonDescription && <p className="program-view-season-description">{seasonDescription}</p>}
        {episodesCount === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
            Nu există episoade în acest sezon.
          </div>
        ) : !isLoaded && episodesCount > 0 ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <button 
              onClick={() => loadSeasonEpisodes(season.id, 100)}
              style={{ 
                padding: '12px 24px', 
                backgroundColor: '#6366f1', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              Încarcă episoadele ({episodesCount})
            </button>
          </div>
        ) : episodes.length > 0 ? (
          <div className="program-view-season-carousel">
            <Slider
              className="program-view-slider"
              slidesToShow={6}
              slidesToScroll={6}
              infinite={false}
              arrows
              dots
              nextArrow={<ArrowButton direction="next" />}
              prevArrow={<ArrowButton direction="prev" />}
              swipeToSlide={true}
              touchThreshold={50}
              clickable={true}
              pauseOnHover={false}
              afterChange={(currentSlide) => {
                // Încarcă mai multe episoade când utilizatorul ajunge aproape de sfârșitul slider-ului
                const totalSlides = Math.ceil(visibleEpisodes.length / 6);
                if (currentSlide >= totalSlides - 2 && hasMoreEpisodes) {
                  loadMoreEpisodes(season.id);
                }
              }}
              responsive={[
                { breakpoint: 1280, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 3, arrows: false, dots: true } },
                { breakpoint: 640, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: false, dots: true } }
              ]}
            >
              {visibleEpisodes.map((episode, index) => renderEpisodeCard(episode, index))}
            </Slider>
          </div>
        ) : (
          <div className="program-view-season-empty">Nu există episoade în acest sezon.</div>
        )}
      </div>
    )
  }

  return (
    <div className="program-view-root">
      <div className="program-view-header">
        <button type="button" className="program-view-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3333 21.6667L3 12.3333M3 12.3333L12.3333 3M3 12.3333H28.6667C31.142 12.3333 33.516 13.3167 35.2663 15.067C37.0167 16.8173 38 19.1913 38 21.6667C38 24.142 37.0167 26.516 35.2663 28.2663C33.516 30.0167 31.142 31 28.6667 31H26.3333" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {loading && <div className="program-view-status">Se încarcă programul...</div>}
      {error && <div className="program-view-status program-view-status-error">{error}</div>}

      {!loading && !error && (
        <div className="program-view-content">
          <div className="program-view-hero">
            <div className="program-view-poster">
              <picture>
                <source media="(max-width: 768px)" srcSet={mobilePoster || desktopPoster || undefined} />
                {desktopPoster ? (
                  <img src={desktopPoster} alt={program.title || 'Program'} />
                ) : (
                  <div className="program-view-placeholder">{program.title?.[0] ?? '?'}</div>
                )}
              </picture>
            </div>
            <h1>{program.title}</h1>
            {programDescription && <p className="program-view-description">{programDescription}</p>}
          </div>

          {!!programLinks.length && (
            <div className="program-view-links">
              {programLinks.map((link, index) => {
                const label = link?.label || link?.title || link?.url || 'Link'
                const url = link?.url || link?.href || null
                if (!url) {
                  return null
                }
                const icon = getSocialIcon(label)
                return (
                  <a
                    key={`${url}-${index}`}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="program-view-link-card"
                  >
                    {icon ? <span className="program-view-link-icon">{icon}</span> : null}
                    <span className="program-view-link-label">{label}</span>
                  </a>
                )
              })}
            </div>
          )}

        </div>
      )}

      {program.seasons && program.seasons.length ? (
        <div className="program-view-seasons">
          <div className="program-view-seasons-header">
            <h2>Sezoane</h2>
            {program.seasons.length > 1 && (
              <select 
                className="program-view-season-selector"
                value={selectedSeasonId || ""}
                onChange={async (e) => {
                  const seasonId = e.target.value ? parseInt(e.target.value) : null;
                  
                  if (seasonId) {
                    setSelectedSeasonId(seasonId);
                    
                    // Resetează lazy loading-ul pentru sezonul selectat
                    setVisibleEpisodesPerSeason(prev => ({
                      ...prev,
                      [seasonId]: 12 // Reîncepe cu 12 episoade
                    }));
                    
                    // Încarcă episoadele sezonului dacă nu sunt deja încărcate
                    if (!loadedSeasons.has(seasonId)) {
                      await loadSeasonEpisodes(seasonId, 100);
                    }
                    
                    // Scroll la sezonul selectat după un mic delay
                    setTimeout(() => {
                      document.getElementById(`season-${seasonId}`)?.scrollIntoView({ behavior: 'smooth' });
                    }, 200);
                  } else {
                    setSelectedSeasonId(null);
                  }
                }}
              >
                <option value="">Selectează un sezon...</option>
                {program.seasons.map((season, index) => (
                  <option key={season.id} value={season.id}>
                    {season.title} ({season.episodes_count || season.episodes?.length || 0} episoade)
                  </option>
                ))}
              </select>
            )}
          </div>
          {isLoadingSeason ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
              Se încarcă sezonul selectat...
            </div>
          ) : (
            (() => {
              if (selectedSeasonId) {
                // Afișează doar sezonul selectat
                const selectedSeason = program.seasons.find(s => s.id === selectedSeasonId);
                if (selectedSeason) {
                  const seasonIndex = program.seasons.findIndex(s => s.id === selectedSeasonId);
                  return [renderSeason(selectedSeason, seasonIndex)];
                }
                return [];
              } else {
                // Afișează doar ultimele 2 sezoane (cele mai recente)
                return program.seasons.slice(0, 2).map((season, seasonIndex) => renderSeason(season, seasonIndex));
              }
            })()
          )}
        </div>
      ) : (
        <div className="program-view-empty">
          <h3>Nu există sezoane disponibile</h3>
          <p>Acest program nu are încă sezoane sau episoade publicate.</p>
        </div>
      )}
    </div>
  )
}

export default ProgramView
